import React from 'react';
import '../template-file-css/document-file-template.css';


export const RRTS_DischargeSummary = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RRTS_DischargeSummary' className='file-pdf-document'>
            <div className='file-template'>


                <h3>RED RIVER THERAPEUTIC SOLUTIONS
                    <br />
                    DISCHARGE SUMMARY
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>REASON FOR DISCHARGE</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCompleted1" id="chkCompleted1" className='add-only' value="Completed" /> Completed Services
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCompleted2" id="chkCompleted2" className='add-only' value="Non" />  Non-Compliance/No Show
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkCompleted3" id="chkCompleted3" className='add-only' value="Transferred" /> Transferred to another agency
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" name="chkCompleted4" id="chkCompleted4" className='add-only' value="Extended" /> Extended inactive status (30 days or more)
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type="checkbox" name="chkCompleted5" id="chkCompleted5" className='add-only' value="Other" /> Other
                            <input type="text" name="txtWeight6" id="txtWeight6" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>TYPE OF DISCHARGE:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPlanned1" id="chkPlanned1" className='add-only' value="Planned" /> Planned Discharge
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPlanned2" id="chkPlanned2" className='add-only' value="Unplanned" /> Unplanned Discharge
                        </td>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPlanned3" id="chkPlanned3" className='add-only' value="Administrative" /> Administrative Discharge
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" name="chkPlanned4" id="chkPlanned4" className='add-only' value="Clinical" /> Clinical Discharge
                        </td>
                        <td className='w-500'>
                            <input type="checkbox" name="chkPlanned5" id="chkPlanned5" className='add-only' value="Other" /> Other
                            <input type="text" name="txtWeight7" id="txtWeight7" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>Assessments of Strengths, NEEDS, Abilities and Preferences (SNAP)
                </h4>
                <p>
                    <span className='eleHeader'>Strengths</span>
                    <textarea id="txtStrengths" name="txtStrengths" className='add-only'> </textarea>
                </p>
                <p>
                    <span className='eleHeader'>Needs</span>
                    <textarea id="txtStrengths1" name="txtStrengths1" className='add-only'> </textarea>
                </p>
                <p>
                    <span className='eleHeader'>Abilities</span>
                    <textarea id="txtStrengths2" name="txtStrengths2" className='add-only'> </textarea>
                </p>
                <p>
                    <span className='eleHeader'>Preferences</span>
                    <textarea id="txtStrengths3" name="txtStrengths3" className='add-only'> </textarea>
                </p>
                <p>
                    <span className='eleHeader'>REASON FOR REFERRAL</span>
                    <textarea id="txtStrengths4" name="txtStrengths4" className='add-only'> </textarea>
                </p>
                <p>
                    <span className='eleHeader'>SUMMARY OF SERVICES PROVIDED</span>
                    <textarea id="txtStrengths5" name="txtStrengths5" className='add-only'> </textarea>
                </p>
                <p>
                    <span className='eleHeader'>PROGRESS MADE AND UNRESOLVED CONCERNS</span>
                    <textarea id="txtStrengths6" name="txtStrengths6" className='add-only'> </textarea>
                </p>
                <h4>LAST ASSESSMENT COMPLETED BY
                </h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name</span>
                            <input type="text" name="txtName" id="txtName" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Title</span>
                            <input type="text" name="txtTitle" id="txtTitle" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date</span>
                            <input type="date" name="txtDate" id="txtDate" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Name</span>
                            <input type="text" name="txtName1" id="txtName1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Title</span>
                            <input type="text" name="txtTitle2" id="txtTitle2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Date</span>
                            <input type="date" name="txtDate3" id="txtDate3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>DIAGNOSES
                </h4>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>ICD-9-CM CODE</span>
                            <input type="text" name="txtName4" id="txtName4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>ICD-10-CM CODE</span>
                            <input type="text" name="txtTitle4" id="txtTitle4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>ICD-10-CM CODE</span>
                            <input type="text" name="txtDate4" id="txtDate4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>MOST RECENT MEDICATIONS
                </h4>
                <table>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>MEDICATION NAME</span>
                            <input type="text" name="txtMedication" id="txtMedication" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>DOSAGE</span>
                            <input type="text" name="txtDosage" id="txtDosage" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>FREQUENCY</span>
                            <input type="text" name="txtFrequecy" id="txtFrequecy" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>INDICATIONS</span>
                            <input type="text" name="txtIndications" id="txtIndications" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>MEDICATION NAME</span>
                            <input type="text" name="txtMedication2" id="txtMedication2" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>DOSAGE</span>
                            <input type="text" name="txtDosage2" id="txtDosage2" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>FREQUENCY</span>
                            <input type="text" name="txtFrequecy2" id="txtFrequecy2" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>INDICATIONS</span>
                            <input type="text" name="txtIndications2" id="txtIndications2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>MEDICATION NAME</span>
                            <input type="text" name="txtMedication3" id="txtMedication3" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>DOSAGE</span>
                            <input type="text" name="txtDosage3" id="txtDosage3" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>FREQUENCY</span>
                            <input type="text" name="txtFrequecy3" id="txtFrequecy3" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>INDICATIONS</span>
                            <input type="text" name="txtIndications3" id="txtIndications3" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>MEDICATION NAME</span>
                            <input type="text" name="txtMedication4" id="txtMedication4" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>DOSAGE</span>
                            <input type="text" name="txtDosage4" id="txtDosage4" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>FREQUENCY</span>
                            <input type="text" name="txtFrequecy4" id="txtFrequecy4" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>INDICATIONS</span>
                            <input type="text" name="txtIndications4" id="txtIndications4" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>MEDICATION NAME</span>
                            <input type="text" name="txtMedication5" id="txtMedication5" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>DOSAGE</span>
                            <input type="text" name="txtDosage5" id="txtDosage5" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>FREQUENCY</span>
                            <input type="text" name="txtFrequecy5" id="txtFrequecy5" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>INDICATIONS</span>
                            <input type="text" name="txtIndications5" id="txtIndications5" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>MEDICATION NAME</span>
                            <input type="text" name="txtMedication6" id="txtMedication6" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>DOSAGE</span>
                            <input type="text" name="txtDosage6" id="txtDosage6" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>FREQUENCY</span>
                            <input type="text" name="txtFrequecy6" id="txtFrequecy6" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>INDICATIONS</span>
                            <input type="text" name="txtIndications6" id="txtIndications6" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h4>AFTERCARE SERVICES
                </h4>
                <table>
                    <tr>
                        <td className='w-187'>
                            <span className='eleHeader'>Referral Source</span>
                            <input type="text" name="txtReferral" id="txtReferral" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Contact Name</span>
                            <input type="text" name="txtContactName" id="txtContactName" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Phone</span>
                            <input type="text" name="txtPhone" id="txtPhone" className='add-only' />
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>Address</span>
                            <input type="text" name="txtAddress" id="txtAddress" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Clinical Recommendations</span>
                            <input type="text" name="txtReferral2" id="txtReferral2" className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date of follow-up completion</span>
                            <input type="date" name="txtContactName2" id="txtContactName2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Designated person to follow-up on continuity of aftercare services</span>
                            <input type="text" name="txtContactName3" id="txtContactName3" className='add-only' />
                        </td>
                        <td className='w-187'> &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Follow-up due within 15 days of discharge</span><span className='small'> (Enter Due Date)</span>
                            <input type="date" name="txtReferral4" id="txtReferral4" className='add-only' />
                        </td>
                        <td className='w-187'> &nbsp;
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>Brief description of result to follow-up</span>
                    Please contact primary physician/parent for any results pertaining to follow-up
                </p>
                <h4>DISCHARGE SUMMARY SIGNATURES
                </h4>
                <table>
                    <tr>
                        <td className='signature w-200'> &nbsp;
                        </td>
                        <td className='signature w-200'> LMHP
                        </td>
                        <td className='signature w-200'> &nbsp;
                        </td>
                        <td className='signature w-150'> &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-200'> Name
                        </td>
                        <td className='small w-200'> Title
                        </td>
                        <td className='small w-200'> Date
                        </td>
                        <td className='small w-150'> Signature
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-200'> &nbsp;
                        </td>
                        <td className='signature w-200'> SITE DIRECTOR
                        </td>
                        <td className='signature w-200'> &nbsp;
                        </td>
                        <td className='signature w-150'> &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-200'> Name
                        </td>
                        <td className='small w-200'> Title
                        </td>
                        <td className='small w-200'> Date
                        </td>
                        <td className='small w-150'> Signature
                        </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}   